import './style.css'

export default class RangeInput {
    static selector = '.range-box'

    constructor(block) {
        this.block = block

        this.rangeInputLeft = this.block.querySelector(".range-box__input-left");
        this.rangeInputRight = this.block.querySelector(".range-box__input-right");

        this.thumbRangeLeft = this.block.querySelector(".range-box__thumb.left");
        this.thumbRangeRight = this.block.querySelector(".range-box__thumb.right");
        this.range = this.block.querySelector(".range-box__range");

        this.minRangeValue = this.block.querySelector('.range-box__min-value')
        this.maxRangeValue = this.block.querySelector('.range-box__max-value')

        this.prefix = this.block.dataset.prefix || '';
        this.suffix = this.block.dataset.suffix || '';
		this.digits = parseInt(this.block.dataset.digits) || 0;
		this.format = this.block.dataset.format || "";

        this.setLeftValue();
        this.setRightValue();

        this.rangeInputLeft.addEventListener("input", this.setLeftValue);
        this.rangeInputRight.addEventListener("input", this.setRightValue);
    }

    setLeftValue = () => {
        let min = parseFloat(this.rangeInputLeft.min),
            max = parseFloat(this.rangeInputLeft.max);

        this.rangeInputLeft.value = Math.min(parseFloat(this.rangeInputLeft.value), parseFloat(this.rangeInputRight.value) - 1);

        const percent = ((this.rangeInputLeft.value - min) / (max - min)) * 100;

        this.thumbRangeLeft.style.left = percent + "%";
        this.range.style.left = percent + "%";

        let value = parseFloat(this.rangeInputLeft.value);
        switch(this.format) {
        	case "currency":
        		value = value.toLocaleString('en-GB');
        		break;
        	default:	
				value = value.toFixed(this.digits);
				break;
        }

        this.minRangeValue.innerText = `${this.prefix} ${value} ${this.suffix}`.trim();
    }

    setRightValue = () => {
        let min = parseFloat(this.rangeInputRight.min),
            max = parseFloat(this.rangeInputRight.max);

        this.rangeInputRight.value = Math.max(parseFloat(this.rangeInputRight.value), parseFloat(this.rangeInputLeft.value) + 1);

        const percent = ((this.rangeInputRight.value - min) / (max - min)) * 100;

        this.thumbRangeRight.style.right = (100 - percent) + "%";
        this.range.style.right = (100 - percent) + "%";

        let value = parseFloat(this.rangeInputRight.value);
        switch(this.format) {
        	case "currency":
        		value = value.toLocaleString('en-GB');
        		break;
        	default:	
				value = value.toFixed(this.digits);
				break;
        }

        this.maxRangeValue.innerText = `${this.prefix} ${value} ${this.suffix}`.trim();
    }
}
